import store from "../../../../store";
import internal_files from './internal_files.vue';

window.internal_inside =  new Vue({
    store,
    el: '#internal_inside',
    name : "internal_inside",

    created () {
        EventBus.$on('sign_doc',this.sign_doc)
    },
    components : {
        internal_files
    },

    methods : {
        async sign_doc(doc_id) {
            console.log('sign_doc',doc_id);
            IMC_CORE.showloading();

            await api.patch('/internal/docs/'+ doc_id + "/sign").then(({data}) => {
                IMC_CORE.hideloading();
                window.location.reload();
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                IMC_CORE.hideloading();
            });

        },
    }
})
